import { defineSlotRecipe } from '@chakra-ui/react/styled-system';

const statSlotRecipe = defineSlotRecipe({
  className: 'stat',
  slots: ['root', 'label', 'value', 'helpText'],
  base: {
    root: {
      display: 'flex',
      flexDirection: 'column',
      gap: '4',
    },
    label: {
      display: 'inline-flex',
      gap: '4',
      alignItems: 'center',
      textStyle: 'body/md/semibold',
    },
    value: {
      display: 'inline-flex',
      gap: '4',
      alignItems: 'center',
      fontFeatureSettings: 'pnum',
      fontVariantNumeric: 'proportional-nums',
    },
    helpText: {
      display: 'inline-flex',
      flexWrap: 'wrap',
      gap: '4',
      textStyle: 'body/md/regular',
    },
  },
  variants: {
    size: {
      lg: {
        label: { color: 'text/primary' },
        value: { textStyle: 'comp/data/sm' },
      },
      '2xl': {
        label: { color: 'text/secondary' },
        value: { textStyle: 'comp/data/md' },
      },
      '3xl': {
        label: { color: 'text/secondary' },
        value: { textStyle: 'comp/data/lg' },
      },
    },
    variant: {
      default: {},
      compact: {
        root: {
          display: 'inline-flex',
          alignItems: 'flex-end',
        },
        value: {
          textStyle: 'body/md/regular',
        },
        helpText: {
          textStyle: 'body/sm/regular',
        },
      },
    },
  },
  defaultVariants: {
    size: 'lg',
    variant: 'default',
  },
});

export default statSlotRecipe;
